/**
 * 운영 체제별 기능 설정
 *
 * 새로운 운영 체제 추가 시 이 파일만 수정하면 됩니다.
 * 컴포넌트 곳곳에 if문을 추가할 필요가 없습니다.
 */

const OPERATION_TYPE_CONFIG = {
  solo: {
    // 기본 정보
    label: '1인 체제',
    description: '원장님 혼자 운영',

    // 메뉴 설정
    menus: [
      { path: '/dashboard', label: '대시보드', icon: 'FiGrid' },
      { path: '/classes', label: '반 관리', icon: 'FiBook' },
      { path: '/students', label: '학생 관리', icon: 'FiUsers' },
      { path: '/attendance', label: '출결 관리', icon: 'FiCheckSquare' },
      { path: '/tests', label: '시험/성적', icon: 'FiAward' },
      { path: '/lessons', label: '일일 리포트', icon: 'FiFileText' },
      { path: '/tuition', label: '수납 관리', icon: 'FiDollarSign' },
      { path: '/notifications', label: '알림 발송', icon: 'FiBell' },
      { path: '/parent-notice', label: '학부모 공지', icon: 'FiBell' },
      { path: '/weekly-reports', label: '주간 리포트', icon: 'FiCalendar' },
      { path: '/monthly-reports', label: '월간 리포트', icon: 'FiCalendar' },
      { path: '/staff-notice', label: '내부 공지', icon: 'FiInbox' },
      { path: '/chat', label: '채팅', icon: 'FiMessageCircle' },
      { path: '/points', label: '포인트', icon: 'FiCreditCard' },
      { path: '/billing', label: '정산', icon: 'FiFileText' },
      { path: '/settings', label: '설정', icon: 'FiSettings' }
    ],

    // 대시보드 위젯
    dashboardWidgets: [
      'totalStudents',
      'activeClasses',
      'todayAttendance',
      'monthlyRevenue',
      'recentLessons',
      'unpaidTuitions'
    ],

    // 기능 플래그
    features: {
      teacherManagement: false,     // 강사 관리 기능
      teacherSelector: false,        // 강사 선택 기능
      teacherStats: false,           // 강사별 통계
      autoFillTeacher: true,         // 강사 자동 입력 (본인)
      advancedPermissions: false,    // 세부 권한 관리
      assistantManagement: false,    // 조교 관리 기능 (Pro 플랜부터)
      assistantSelector: false       // 조교 선택 기능
    },

    // 수업일지 추천 설정
    lessonReportDefaults: {
      targetType: 'student',  // 1:1 개별맞춤이 많음
      frequency: 'daily'
    },

    // 추천 플랜
    recommendedPlan: {
      type: 'free',
      message: '원장님 혼자 운영하시는군요! 🎯\nFree 플랜으로도 충분히 사용하실 수 있어요.\n학생 50명까지 무료입니다.',
      features: [
        '학생 50명까지 무료',
        '기본 학원 관리 기능',
        '알림 발송 (건당 과금)'
      ]
    }
  },

  team: {
    // 기본 정보
    label: '다인 체제',
    description: '원장님 + 강사진',

    // 메뉴 설정 (직원 관리 추가)
    menus: [
      { path: '/dashboard', label: '대시보드', icon: 'FiGrid' },
      { path: '/classes', label: '반 관리', icon: 'FiBook' },
      { path: '/students', label: '학생 관리', icon: 'FiUsers' },
      { path: '/staff', label: '직원 관리', icon: 'FiUserCheck' }, // 강사+조교 통합
      { path: '/attendance', label: '출결 관리', icon: 'FiCheckSquare' },
      { path: '/tests', label: '시험/성적', icon: 'FiAward' },
      { path: '/lessons', label: '일일 리포트', icon: 'FiFileText' },
      { path: '/tuition', label: '수납 관리', icon: 'FiDollarSign' },
      { path: '/notifications', label: '알림 발송', icon: 'FiBell' },
      { path: '/parent-notice', label: '학부모 공지', icon: 'FiBell' },
      { path: '/weekly-reports', label: '주간 리포트', icon: 'FiCalendar' },
      { path: '/monthly-reports', label: '월간 리포트', icon: 'FiCalendar' },
      { path: '/staff-notice', label: '내부 공지', icon: 'FiInbox' },
      { path: '/chat', label: '채팅', icon: 'FiMessageCircle' },
      { path: '/points', label: '포인트', icon: 'FiCreditCard' },
      { path: '/billing', label: '정산', icon: 'FiFileText' },
      { path: '/settings', label: '설정', icon: 'FiSettings' }
    ],

    // 대시보드 위젯 (강사 통계 추가)
    dashboardWidgets: [
      'totalStudents',
      'activeTeachers',           // 추가
      'activeClasses',
      'todayAttendance',
      'monthlyRevenue',
      'teacherPerformance',       // 추가
      'recentLessons',
      'unpaidTuitions'
    ],

    // 기능 플래그
    features: {
      teacherManagement: true,       // 강사 관리 기능
      teacherSelector: true,         // 강사 선택 기능
      teacherStats: true,            // 강사별 통계
      autoFillTeacher: false,        // 강사 자동 입력 안 함
      advancedPermissions: true,     // 세부 권한 관리
      assistantManagement: true,     // 조교 관리 기능 (플랜별 제한은 별도 체크)
      assistantSelector: true        // 조교 선택 기능
    },

    // 수업일지 추천 설정
    lessonReportDefaults: {
      targetType: 'class',  // 반별 수업이 일반적
      frequency: 'daily'
    },

    // 추천 플랜
    recommendedPlan: {
      type: 'basic',
      message: '강사진과 함께 운영하시는군요! 👥\nBasic 또는 Pro 플랜을 추천드립니다.\n강사 계정 무제한 + 더 많은 기능을 이용하세요.',
      features: [
        '강사 계정 무제한',
        '학생 수 제한 없음',
        '월 10,000P 지급',
        '강사별 통계 및 권한 관리'
      ]
    }
  }
};

/**
 * operationType으로 설정 가져오기
 */
export const getOperationConfig = (operationType = 'solo') => {
  return OPERATION_TYPE_CONFIG[operationType] || OPERATION_TYPE_CONFIG.solo;
};

/**
 * 특정 기능 사용 가능 여부 확인
 */
export const hasFeature = (operationType, featureName) => {
  const config = getOperationConfig(operationType);
  return config.features[featureName] || false;
};

/**
 * 메뉴 목록 가져오기
 */
export const getMenus = (operationType) => {
  const config = getOperationConfig(operationType);
  return config.menus;
};

/**
 * 대시보드 위젯 목록 가져오기
 */
export const getDashboardWidgets = (operationType) => {
  const config = getOperationConfig(operationType);
  return config.dashboardWidgets;
};

/**
 * 추천 플랜 정보 가져오기
 */
export const getRecommendedPlan = (operationType) => {
  const config = getOperationConfig(operationType);
  return config.recommendedPlan;
};

/**
 * 수업일지 작성 주기 설정에 따라 메뉴 필터링
 * @param {string} operationType - 운영 체제 타입
 * @param {Array<string>} frequencies - 작성 주기 배열 ['daily', 'weekly', 'monthly']
 * @returns {Array} 필터링된 메뉴 목록
 */
export const getFilteredMenus = (operationType, frequencies = ['daily']) => {
  const allMenus = getMenus(operationType);

  // frequencies가 없거나 배열이 아니면 daily만 있다고 간주
  const activeFrequencies = Array.isArray(frequencies) && frequencies.length > 0
    ? frequencies
    : ['daily'];

  // 필터링할 메뉴 경로 매핑
  const frequencyMenuMap = {
    'daily': '/lessons',
    'weekly': '/weekly-reports',
    'monthly': '/monthly-reports'
  };

  // 활성화된 주기에 해당하는 메뉴 경로만 포함
  const allowedPaths = Object.entries(frequencyMenuMap)
    .filter(([frequency, _]) => activeFrequencies.includes(frequency))
    .map(([_, path]) => path);

  // 메뉴 필터링
  return allMenus.filter(menu => {
    // 리포트 관련 메뉴가 아니면 항상 포함
    const reportPaths = Object.values(frequencyMenuMap);
    if (!reportPaths.includes(menu.path)) {
      return true;
    }

    // 리포트 메뉴는 활성화된 주기에 포함된 경우만 표시
    return allowedPaths.includes(menu.path);
  });
};

export default OPERATION_TYPE_CONFIG;
